import * as T from 'types'

export const getAgreementFromListing = (listing?: T.IListing): T.IListingMlsDocument | undefined =>
  listing?.mlsList?.[0]?.documents?.find(doc => doc.listingAgreement)
